// @ts-nocheck
import React, { FC } from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import constants from "@store/constants";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Zone from "@insite/client-framework/Components/Zone";
import { useIsSearchPage } from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/ProductListHooks";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import { isNonEmptyString } from "@insite/client-framework/Common/Utilities/StringUtilities";

export interface WaveWrapperProps extends WidgetProps, HasCategoryContext {
    id: string;
}

const ProductLsitHeader: FC<WaveWrapperProps> = ({ id, category }) => {
    const isSearchPage = useIsSearchPage();
    const hasImage =
        category && isNonEmptyString(category.largeImagePath) && !category.largeImagePath.includes("NotFound");

    if (isSearchPage || !hasImage) {
        return <Zone contentId={id} zoneName="SearchContent" />;
    }

    return <Zone contentId={id} zoneName="Content" />;
};
const widgetModule: WidgetModule<Toolkit.FieldDefinition> = {
    component: withCategory(ProductLsitHeader),
    definition: {
        group: constants.widgetGroup.layout,
        displayName: "Product List Header",
        allowedContexts: ["ProductListPage"],
        icon: "table-layout",
    },
};
export default widgetModule;
